export default __webpack_public_path__ + "static/media/IconNotificacoes.c885a3f1.svg";